import React from "react";
import { STICKY_FOOTER_BANNER_MWEB } from "../../helpers/brazePlacementIds";
import BrazeBannerSlot from "../../components/Braze/BrazeBannerSlot";
import styles from "./home.module.scss";

type StickyFooterBrazeBannerProps = {
  placementActive?: boolean;
};

/** Sticky full-width footer banner above the bottom nav (1272×118px, mobile). */
const StickyFooterBrazeBanner: React.FC<StickyFooterBrazeBannerProps> = ({
  placementActive = true,
}) => (
  <BrazeBannerSlot
    placementId={STICKY_FOOTER_BANNER_MWEB}
    logLabel="StickyFooterBrazeBanner"
    className={`${styles.stickyFooterBannerSlot} ${
      placementActive ? "" : styles.stickyFooterBannerSlotHidden
    }`.trim()}
    ariaLabel="Promotional footer banner"
    placementActive={placementActive}
    keepMounted
  />
);

export default StickyFooterBrazeBanner;
